"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAgentAdminPlatformSummaryResponseSchema = exports.APosAgentAdminPlatformSummaryPurchaseSchema = exports.APosAgentAdminPlatformSummaryTopTenantSchema = exports.APosAgentAdminPlatformSummaryTotalsSchema = exports.APosAgentAdminPlatformSummaryRequestSchema = exports.APosAgentAdminTenantPricingPutResponseSchema = exports.APosAgentAdminTenantPricingFullGetResponseSchema = exports.APosAgentAdminTenantPricingApiViewSchema = exports.APosAgentAdminTenantExportRequestSchema = exports.APosAgentAdminTenantExportFormatSchema = exports.APosAgentAdminTenantSummaryResponseSchema = exports.APosAgentAdminTenantSummaryTotalsSchema = exports.APosAgentAdminTenantSummaryPerOperationSchema = exports.APosAgentAdminTenantSummaryPerApiSchema = exports.APosAgentAdminTenantSummaryRequestSchema = exports.APosAgentAdminDeductResponseSchema = exports.APosAgentAdminGrantResponseSchema = exports.APosAgentAdminTenantHistoryResponseSchema = exports.APosAgentAdminTenantHistoryRequestSchema = exports.APosAgentAdminDeductRequestSchema = exports.APosAgentAdminGrantRequestSchema = exports.APosAgentAdminTenantPricingPutRequestSchema = exports.APosAgentAdminTenantPricingGetResponseSchema = exports.APosAgentAdminPendingDismissRequestSchema = exports.APosAgentAdminPendingApplyRequestSchema = exports.APosAgentAdminPendingListResponseSchema = exports.APosAgentAdminPricingPutResponseSchema = exports.APosAgentAdminPricingPutRequestSchema = exports.APosAgentAdminPricingGetResponseSchema = void 0;
const zod_1 = require("zod");
const agent_pricing_schema_1 = require("../../entities/agenticpos/agent-pricing.schema");
const agent_credits_schema_1 = require("../../entities/agenticpos/agent-credits.schema");
/**
 * AgenticPOS AI Agent — Super-admin API schemas
 *
 * Wave 0 endpoints implemented:
 *   GET /agents/admin/pricing
 *   PUT /agents/admin/pricing
 *
 * Schemas for Wave 1 admin endpoints (tenant pricing, grant/deduct,
 * history, export, pending queue, platform summary) are declared
 * here so the entire admin surface is typed in one place.
 */
// ---------- GET /agents/admin/pricing ----------
exports.APosAgentAdminPricingGetResponseSchema = zod_1.z.object({
    config: agent_pricing_schema_1.APosAgentPricingConfigRowSchema,
});
// ---------- PUT /agents/admin/pricing ----------
exports.APosAgentAdminPricingPutRequestSchema = zod_1.z.object({
    /** Full or partial API registry patch. Merged with existing row. */
    apis: agent_pricing_schema_1.APosAgentApiRegistrySchema.partial().optional(),
    /** Full or partial operation registry patch. */
    operations: zod_1.z
        .record(zod_1.z.string(), agent_pricing_schema_1.APosAgentOperationDefinitionSchema)
        .optional(),
    creditUnitPriceUsd: zod_1.z.number().positive().optional(),
    minPurchaseCredits: zod_1.z.number().int().positive().optional(),
    /** Free-form audit note recorded in changeHistory. */
    note: zod_1.z.string().optional(),
});
exports.APosAgentAdminPricingPutResponseSchema = zod_1.z.object({
    config: agent_pricing_schema_1.APosAgentPricingConfigRowSchema,
    applied: zod_1.z.boolean(),
});
// ---------- GET /agents/admin/pricing/pending (Wave 1) ----------
exports.APosAgentAdminPendingListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(agent_pricing_schema_1.APosAgentPricingPendingChangeRowSchema),
});
// ---------- POST /agents/admin/pricing/pending/{id}/apply (Wave 1) ----------
exports.APosAgentAdminPendingApplyRequestSchema = zod_1.z.object({
    actionNote: zod_1.z.string().optional(),
});
exports.APosAgentAdminPendingDismissRequestSchema = zod_1.z.object({
    actionNote: zod_1.z.string().optional(),
});
// ---------- GET /agents/admin/tenant/{tenantId}/pricing (Wave 1) ----------
exports.APosAgentAdminTenantPricingGetResponseSchema = zod_1.z.object({
    override: agent_pricing_schema_1.APosAgentPricingTenantOverrideRowSchema.nullable(),
    resolved: zod_1.z.object({
        apis: zod_1.z.record(zod_1.z.string(), zod_1.z.object({
            burnRate: zod_1.z.number().nonnegative(),
            minCreditsPerCall: zod_1.z.number().int().nonnegative(),
            isFree: zod_1.z.boolean(),
            isEnabled: zod_1.z.boolean(),
            source: zod_1.z.enum(['tenant', 'global']),
        })),
        minPurchaseCredits: zod_1.z.number().int().positive(),
    }),
});
// ---------- PUT /agents/admin/tenant/{tenantId}/pricing (Wave 1) ----------
exports.APosAgentAdminTenantPricingPutRequestSchema = zod_1.z.object({
    apis: zod_1.z
        .object({
        anthropic: zod_1.z
            .object({
            burnRateOverride: zod_1.z.number().nonnegative().max(50).optional(),
            free: zod_1.z.boolean().optional(),
        })
            .optional(),
        google_vertex: zod_1.z
            .object({
            burnRateOverride: zod_1.z.number().nonnegative().max(50).optional(),
            free: zod_1.z.boolean().optional(),
        })
            .optional(),
        google_cse: zod_1.z
            .object({
            burnRateOverride: zod_1.z.number().nonnegative().max(50).optional(),
            free: zod_1.z.boolean().optional(),
        })
            .optional(),
    })
        .optional(),
    minPurchaseCredits: zod_1.z.number().int().positive().nullable().optional(),
    note: zod_1.z.string().optional(),
});
// ---------- POST /agents/admin/tenant/{tenantId}/grant (Wave 1) ----------
exports.APosAgentAdminGrantRequestSchema = zod_1.z.object({
    credits: zod_1.z.number().int().min(1).max(500),
    reason: zod_1.z.string().max(500).optional(),
    idempotencyKey: zod_1.z.string().min(1).optional(),
});
// ---------- POST /agents/admin/tenant/{tenantId}/deduct (Wave 1) ----------
exports.APosAgentAdminDeductRequestSchema = zod_1.z.object({
    credits: zod_1.z.number().int().min(1).max(500),
    reason: zod_1.z.string().max(500).optional(),
    idempotencyKey: zod_1.z.string().min(1).optional(),
    /** Client must echo back "DEDUCT" to confirm. */
    typedConfirmation: zod_1.z.literal('DEDUCT'),
});
// ---------- GET /agents/admin/tenant/{tenantId}/history (Wave 1) ----------
exports.APosAgentAdminTenantHistoryRequestSchema = zod_1.z.object({
    fromIso: zod_1.z.string().optional(),
    toIso: zod_1.z.string().optional(),
    types: zod_1.z.array(agent_credits_schema_1.APosAgentCreditTransactionTypeSchema).optional(),
    operations: zod_1.z.array(agent_credits_schema_1.APosAgentCreditOperationSchema).optional(),
    limit: zod_1.z.number().int().positive().max(100).default(20),
    exclusiveStartKey: zod_1.z.string().optional(),
});
exports.APosAgentAdminTenantHistoryResponseSchema = zod_1.z.object({
    items: zod_1.z.array(agent_credits_schema_1.APosAgentCreditLedgerRowSchema),
    lastEvaluatedKey: zod_1.z.string().nullable().optional(),
    count: zod_1.z.number().int().nonnegative(),
});
// ===========================================================================
// Wave 1.5 — additional admin schemas
// ===========================================================================
// ---------- POST /agents/admin/credits/tenants/{tenantId}/grant response ----------
exports.APosAgentAdminGrantResponseSchema = zod_1.z.object({
    balance: zod_1.z.number().nonnegative(),
    ledgerRow: agent_credits_schema_1.APosAgentCreditLedgerRowSchema.nullable(),
});
// ---------- POST /agents/admin/credits/tenants/{tenantId}/deduct response ----------
exports.APosAgentAdminDeductResponseSchema = zod_1.z.object({
    balance: zod_1.z.number().nonnegative(),
    ledgerRow: agent_credits_schema_1.APosAgentCreditLedgerRowSchema.nullable(),
});
// ---------- GET /agents/admin/credits/tenants/{tenantId}/summary ----------
exports.APosAgentAdminTenantSummaryRequestSchema = zod_1.z.object({
    fromIso: zod_1.z.string().optional(),
    toIso: zod_1.z.string().optional(),
});
exports.APosAgentAdminTenantSummaryPerApiSchema = zod_1.z.object({
    api: zod_1.z.string(),
    calls: zod_1.z.number().int().nonnegative(),
    realCostUsd: zod_1.z.number().nonnegative(),
    creditsConsumed: zod_1.z.number().int().nonnegative(),
    revenueUsd: zod_1.z.number().nonnegative(),
});
exports.APosAgentAdminTenantSummaryPerOperationSchema = zod_1.z.object({
    operation: zod_1.z.string(),
    calls: zod_1.z.number().int().nonnegative(),
    credits: zod_1.z.number().int().nonnegative(),
});
exports.APosAgentAdminTenantSummaryTotalsSchema = zod_1.z.object({
    calls: zod_1.z.number().int().nonnegative(),
    realCostUsd: zod_1.z.number().nonnegative(),
    credits: zod_1.z.number().int().nonnegative(),
    revenueUsd: zod_1.z.number().nonnegative(),
    grossMarginUsd: zod_1.z.number(),
    grossMarginPercent: zod_1.z.number(),
});
exports.APosAgentAdminTenantSummaryResponseSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    balance: zod_1.z.number().nonnegative(),
    timeRange: zod_1.z.object({
        fromIso: zod_1.z.string(),
        toIso: zod_1.z.string(),
    }),
    perApi: zod_1.z.array(exports.APosAgentAdminTenantSummaryPerApiSchema),
    perOperation: zod_1.z.array(exports.APosAgentAdminTenantSummaryPerOperationSchema),
    totals: exports.APosAgentAdminTenantSummaryTotalsSchema,
});
// ---------- GET /agents/admin/credits/tenants/{tenantId}/export ----------
exports.APosAgentAdminTenantExportFormatSchema = zod_1.z.enum(['csv', 'pdf']);
exports.APosAgentAdminTenantExportRequestSchema = zod_1.z.object({
    format: exports.APosAgentAdminTenantExportFormatSchema,
    fromIso: zod_1.z.string().optional(),
    toIso: zod_1.z.string().optional(),
    types: zod_1.z.array(agent_credits_schema_1.APosAgentCreditTransactionTypeSchema).optional(),
    operations: zod_1.z.array(agent_credits_schema_1.APosAgentCreditOperationSchema).optional(),
});
// ---------- GET /agents/admin/tenants/{tenantId}/pricing — full resolved response ----------
// Wave 1.5 replaces the Wave 1 shape (which was override+resolved) with a
// richer view that exposes the global defaults and per-API effective rates.
exports.APosAgentAdminTenantPricingApiViewSchema = zod_1.z.object({
    global: zod_1.z.object({
        burnRate: zod_1.z.number().nonnegative(),
        minCreditsPerCall: zod_1.z.number().int().nonnegative(),
    }),
    override: zod_1.z
        .object({
        burnRate: zod_1.z.number().nonnegative().nullable().optional(),
        free: zod_1.z.boolean().optional(),
    })
        .nullable(),
    effective: zod_1.z.object({
        burnRate: zod_1.z.number().nonnegative(),
        minCreditsPerCall: zod_1.z.number().int().nonnegative(),
        isFree: zod_1.z.boolean(),
    }),
});
exports.APosAgentAdminTenantPricingFullGetResponseSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    apis: zod_1.z.object({
        anthropic: exports.APosAgentAdminTenantPricingApiViewSchema,
        google_vertex: exports.APosAgentAdminTenantPricingApiViewSchema,
        google_cse: exports.APosAgentAdminTenantPricingApiViewSchema,
    }),
    minPurchaseCredits: zod_1.z.object({
        global: zod_1.z.number().int().positive(),
        override: zod_1.z.number().int().positive().nullable(),
        effective: zod_1.z.number().int().positive(),
    }),
    auditLog: zod_1.z.array(zod_1.z.object({
        at: zod_1.z.string(),
        by: zod_1.z.string(),
        diff: zod_1.z.unknown(),
        note: zod_1.z.string().optional(),
    })),
});
// ---------- PUT /agents/admin/tenants/{tenantId}/pricing response ----------
exports.APosAgentAdminTenantPricingPutResponseSchema = zod_1.z.object({
    override: agent_pricing_schema_1.APosAgentPricingTenantOverrideRowSchema,
});
// ---------- GET /agents/admin/credits/summary — platform rollup ----------
exports.APosAgentAdminPlatformSummaryRequestSchema = zod_1.z.object({
    fromIso: zod_1.z.string().optional(),
    toIso: zod_1.z.string().optional(),
});
exports.APosAgentAdminPlatformSummaryTotalsSchema = zod_1.z.object({
    creditsSold: zod_1.z.number().int().nonnegative(),
    creditsConsumed: zod_1.z.number().int().nonnegative(),
    creditsGranted: zod_1.z.number().int().nonnegative(),
    creditsDeducted: zod_1.z.number().int().nonnegative(),
    revenueUsd: zod_1.z.number().nonnegative(),
    cogsUsd: zod_1.z.number().nonnegative(),
    grossMarginUsd: zod_1.z.number(),
    grossMarginPercent: zod_1.z.number(),
    netOutstandingCredits: zod_1.z.number().nonnegative(),
    activeTenants: zod_1.z.number().int().nonnegative(),
});
exports.APosAgentAdminPlatformSummaryTopTenantSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    creditsConsumed: zod_1.z.number().int().nonnegative(),
    realCostUsd: zod_1.z.number().nonnegative(),
    calls: zod_1.z.number().int().nonnegative(),
});
exports.APosAgentAdminPlatformSummaryPurchaseSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    credits: zod_1.z.number().int().positive(),
    stripePaymentIntentId: zod_1.z.string().optional(),
    bundleLabel: zod_1.z.string().optional(),
    createdAt: zod_1.z.string(),
});
exports.APosAgentAdminPlatformSummaryResponseSchema = zod_1.z.object({
    timeRange: zod_1.z.object({
        fromIso: zod_1.z.string(),
        toIso: zod_1.z.string(),
    }),
    totals: exports.APosAgentAdminPlatformSummaryTotalsSchema,
    topTenants: zod_1.z.array(exports.APosAgentAdminPlatformSummaryTopTenantSchema),
    recentPurchases: zod_1.z.array(exports.APosAgentAdminPlatformSummaryPurchaseSchema),
    notes: zod_1.z.array(zod_1.z.string()).optional(),
});
//# sourceMappingURL=agent-admin.schema.js.map